import { env } from '../../common/util'
import { FINANCIAL_SUMMARY_PRESET_IDS, FOLLOW_UP_EMAIL_PRESET_IDS } from '../../views/MeetingSummary/CRM/PresetMappings'

export const TEMPLATE_TYPE_MAPPING = {
  [FINANCIAL_SUMMARY_PRESET_IDS[env]]: 'Summary template',
  [FOLLOW_UP_EMAIL_PRESET_IDS[env]]: 'E-mail template',
}
